import React from 'react';
import Img from '../../Img';
import { LinkAnchor } from '../../Links';
import config from '../../../../config';
import { userIsProCollegeClubOwner } from '../../../utils/user';
import styles from './studentContent.scss';

// eslint-disable-next-line arrow-body-style
const Row = (props) => {
    return (
        <div className={styles.row}>
            <div className={`row`}>
                <div className={`col-8`}>
                    <div className={styles.title}>{props.title}</div>
                </div>
                <div className={`col-4`}>
                    <div className={styles.value} data-test={props.testId}>{props.value || (props.isOwnProfile ? '' : 'Available upon request')}</div>
                </div>
            </div>
        </div>
    );
};

class StudentTabContent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    buildRowValues(studentInfo, profileData, isOwnProfile, user) {
        const dateArr = studentInfo?.graduationDate ? studentInfo.graduationDate.split('-') : null;
        const canDownload = isOwnProfile || userIsProCollegeClubOwner(user);
        const renderDownload = (path) => (
            <LinkAnchor link={`${config.apiHost}/v1/player/${profileData.id}/${path}`} useAnchor={true}>
                Download
            </LinkAnchor>
        );
        return [
            dateArr ? `${dateArr[1]}/${dateArr[0]}` : '',
            studentInfo.highSchoolGpa || '',
            studentInfo.scores?.sat || '',
            studentInfo.scores?.act || '',
            studentInfo.scores?.toefl || '',
            studentInfo.coursework || '',
            studentInfo.majorOfInterest || '',
            studentInfo.transcriptFileName && canDownload
                ? renderDownload('studentinfo/transcript')
                : '',
            studentInfo.tennisResumeFileName && canDownload
                ? renderDownload('studentinfo/tennisresume')
                : '',
        ];
    }

    render() {
        const { profileData, isOwnProfile, user } = this.props;
        const studentInfo = profileData.studentInfo || {};

        const rows = [
            { title: 'Graduating Month and Year', testId: 'gradMonthAndYear' },
            { title: 'High School GPA', testId: 'highSchoolGpa' },
            { title: 'SAT Score', testId: 'satScore' },
            { title: 'ACT Score', testId: 'actScore' },
            { title: 'TOEFL Score', testId: 'toeflScore' },
            { title: 'Current Coursework', testId: 'currentCoursework' },
            { title: 'Major of Interest', testId: 'majorOfInterest' },
            { title: 'Transcript', testId: 'transcript' },
            { title: 'Tennis Resume', testId: 'tennisResume' },
        ];

        const values = this.buildRowValues(studentInfo, profileData, isOwnProfile, user);

        return (
            <div className={styles.container}>
                <div className={`bb ${styles.schoolWrapper} `}>
                    <div className={styles.school}>
                        <div className={styles.logo}>
                            <Img className="avatar" src={'/img/v2/icons/icon-avatar-player.svg'} />
                        </div>
                        <div className={styles.schoolDetails}>
                            <div className={styles.name} data-test="schoolName">
                                {studentInfo.highSchoolName || '-N/A-'}
                            </div>
                            <div className={styles.address} data-test="schoolAddress">
                                {studentInfo.highSchoolLocation || ''}
                            </div>
                        </div>
                    </div>
                    {isOwnProfile && (
                        <div
                            className={`clickable link ${styles.link}`}
                            onClick={this.props.showEditForm}
                            data-test="editButton"
                            data-testid="profile.student-info.edit-btn"
                        >
                            Edit
                        </div>
                    )}
                </div>
                {rows.map((row, i) => <Row key={`row-${row.title}`} title={row.title} value={values[i]} testId={row.testId} isOwnProfile={isOwnProfile} />)}
            </div>
        );
    }
}

export default StudentTabContent;
